var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 9.77c0-3.143 2.804-5.603 6.191-5.603.63 0 1.24.084 1.812.242a.44.44 0 01.28.597.497.497 0 01-.59.281 5.922 5.922 0 00-1.502-.19c-2.969 0-5.26 2.135-5.26 4.674a4.246 4.246 0 00.823 2.521 2.612 2.612 0 01.08 2.49l.019-.004c.185-.044.35-.085.472-.124a.465.465 0 11.288.885 7.375 7.375 0 01-.546.144l-.06.014c-.164.04-.304.072-.407.103-.308.091-.645-.006-.821-.296-.163-.268-.122-.586.026-.83a.464.464 0 01.028-.04 1.682 1.682 0 00.128-1.855 5.175 5.175 0 01-.961-3.008zM16.507 9.757c0 3.144-2.812 5.604-6.192 5.604-.609 0-1.215-.08-1.803-.238a.465.465 0 01.242-.898c.509.136 1.034.206 1.561.206 2.962 0 5.261-2.135 5.261-4.674 0-.325-.037-.642-.107-.95-.06-.26.08-.536.338-.609a.434.434 0 01.548.303c.1.402.152.822.152 1.256z",
    fill: "#5C8FDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 10.486a.666.666 0 10-.1-1.328.666.666 0 00.1 1.328zM10.301 10.488a.666.666 0 100-1.333.666.666 0 000 1.333zM12.82 10.487a.665.665 0 10.138-1.322.665.665 0 00-.138 1.322z",
    fill: "#5C8FDC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5.833,
    r: 1.667,
    fill: "#5C8FDC"
  })));
}
export default SvgUnreadAction;